<template>
<div class="chapter">
<div class="inner_page">
<p class="fhead">Acknowledgements</p>
<p class="noindent">A huge thank-you to the always knowledgeable and ever helpful staff at the Grand Rapids Public Library Local History Department. Especially Tim Gleisner, head of special collections, for his help in finding hidden treasure, and Julie Tabberer for the great job she did on many of the scans in this book. Thanks also to Alex Forist, collection curator at the Grand Rapids Public Museum. Elaine Snyder from the Byron Museum and Historical Museum and Elizabeth Druga, audiovisual archivist at the Gerald R. Ford Presidential Library, provided images. Thank you. Also, kudos to the unknown and unsung people everywhere who save old photographs and old stories that make local histories possible to re-create.</p>
<p class="indent">I am indebted to Jeff Lobdell, president of Restaurant Partners Inc., who generously shared his intimate knowledge of the Grand Rapids restaurant scene. And to Tom Maas from the Wyoming Historical Commission for not only his help but also his enthusiasm for this project. Thanks, too, to Rick Mack at the Choo Choo, Matt Dowdy, Bill Koski and Matt Rule at the Gilmore Collection, as well as Dan Verhill at the Cottage Bar.</p>
<p class="indent">A huge thank-you to Krista Slavicek, who held my hand when necessary and gently guided me through the History Press process, and Ryan Finn for a terrific edit. Any errors are mine alone. Thanks also to all the behind-the-scenes people at Arcadia Publishing/The History Press who work so hard making great things happen.</p>
<p class="indent">I appreciate the help and support given by my friends at the West Michigan Writer’s Workshop. You’re the best! My granddaughter Shelby Ayers stepped up when I needed her, and so did my daughter, Rhonda Ayers. I love you both and thank you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?2b29ebe8